import type { CompanyEventType } from "@/modules/companies/client/api/contentBoostTypes"
import type { TFunction } from "@/modules/i18n/components/types"

export const getEventTranslationKey = (type: CompanyEventType, t: TFunction<"companies_client">): string => {
  return {
    EVENT_TYPE_CHAT: t("companies_client.content_boosts.event_type.chat"),
    EVENT_TYPE_COACHING: t("companies_client.content_boosts.event_type.coaching"),
    EVENT_TYPE_CONFERENCE: t("companies_client.content_boosts.event_type.conference"),
    EVENT_TYPE_CONTEST: t("companies_client.content_boosts.event_type.contest"),
    EVENT_TYPE_MEETING: t("companies_client.content_boosts.event_type.meeting"),
    EVENT_TYPE_NETWORKING: t("companies_client.content_boosts.event_type.networking"),
    EVENT_TYPE_PODCAST: t("companies_client.content_boosts.event_type.podcast"),
    EVENT_TYPE_RECRUITMENT: t("companies_client.content_boosts.event_type.recruitment"),
    EVENT_TYPE_UNSPECIFIED: t("companies_client.content_boosts.event_type.unspecified"),
    EVENT_TYPE_VIDEO: t("companies_client.content_boosts.event_type.video"),
    EVENT_TYPE_VISIT: t("companies_client.content_boosts.event_type.visit"),
    EVENT_TYPE_WORKSHOP: t("companies_client.content_boosts.event_type.workshop"),
  }[type]
}
